import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import React, { FC, SyntheticEvent, useEffect, useState } from 'react';
import { IStore } from 'common/interfaces/istore';
import { useStoreActions } from 'actions/store-actions';
import { Alert, Box, Button } from '@mui/material';
import classes from './StoreSelection.module.scss';
import UILogger from 'common/utils/logger';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

type StoreSelectionViewProps = {
  onSubmit: (items: IStore[] | undefined) => void;
  reset?: boolean;
  franchiseeId?: number;
  selectedStores?: IStore[];
};

const StoreSelectionView: FC<StoreSelectionViewProps> = ({ reset, selectedStores, franchiseeId, onSubmit }) => {
  const [_stores, setStores] = useState<readonly IStore[]>([]);
  const [selectedItems, setSelectedItems] = useState<IStore[]>(selectedStores || []);

  const [inputValue, setInputValue] = React.useState<string>('');
  const [errorMsg, setErrorMsg] = React.useState<string>();

  const { searchStores } = useStoreActions();

  const _searchStores = async (inputValue: string) => {
    const data = await searchStores({ term: inputValue, franchiseeId: franchiseeId || 0 }, 1, 10);
    setStores(data.items || []);
  };
  useEffect(() => {
    if (inputValue) {
      _searchStores(inputValue);
    }
  }, [inputValue]);

  useEffect(() => {
    UILogger.info('StoreSelectionView: selectedStores:', selectedStores);
    setSelectedItems(selectedStores || []);
  }, [selectedStores]);

  useEffect(() => {
    if (reset) {
      setSelectedItems(selectedStores || []);
    }
  }, [reset]);

  const _onSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    // setSelectedItems
    console.log('event:', event.target.value);
  };

  const _onSubmit = () => {
    if (selectedItems && selectedItems.length > 0) {
      onSubmit && onSubmit(selectedItems);
    } else {
      setErrorMsg('Select store to submit.');
    }
  };

  return (
    <Box
      component="div"
      sx={{
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
      }}
    >
      {errorMsg ? <Alert severity="error">{errorMsg}</Alert> : null}
      <Box
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        gap={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          options={_stores}
          disableCloseOnSelect
          onOpen={() => _searchStores('')}
          getOptionLabel={(option) => option.storeName + '| #' + option.storeNumber + '| zip: ' + option.zipcode}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          value={selectedItems}
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;
            return (
              <li key={key} {...optionProps}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                  onChange={_onSelect}
                />
                <span className={classes.storeOptionLabel}>{'#'}</span>
                <span className={classes.storeOptionText}>{option.storeNumber}</span>
                <span className={classes.storeOptionLabel}>{'   name:'}</span>
                <span className={classes.storeOptionText}>{option.storeName}</span>
                <span className={classes.storeOptionLabel}>{'   zip: '}</span>
                <span className={classes.storeOptionText}>{option.zipcode}</span>
              </li>
            );
          }}
          // fullWidth
          // style={{ width: '100%' }}
          style={{}}
          renderInput={(params) => <TextField {...params} label="Stores" placeholder="Search Stores" />}
          onChange={(event, newValue) => {
            setSelectedItems(newValue);
            // console.log('>>>>>>', newValue);
          }}
        />
        <Button variant="outlined" color="secondary" onClick={_onSubmit} style={{ height: '50px' }}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default StoreSelectionView;
